// extracted by mini-css-extract-plugin
module.exports = {"container":"g7_e","header":"g7_cc","alignCenter":"g7_g8","logoContainer":"g7_g9","logo":"g7_cz","title":"g7_eg"};